import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AxiosError } from 'axios';
import { BrowserRouter } from 'react-router-dom';
import CustomLoader from './components/common/CustomLoader';
import useGetConfiguration from './hooks/useGetConfiguration';
import useGetConnectionType from './hooks/useGetConnectionType';
import ErrorPage from './pages/ErrorPage';
import MaintenancePage from './pages/MaintenancePage';
import Auth0ProviderWithRedirectCallback from './providers/Auth0ProviderWithRedirectCallback';
import AuthProviderWrapper from './providers/AuthProviderWrapper';
import { QualityCheckCacheProvider } from './providers/QualityCheckCacheProvider';
import UserProvider from './providers/UserProvider';
import AppRoutes from './routes/AppRoutes';
import { AUTH_TYPE } from './types/auth';

function App() {
  const { data, error, isLoading } = useGetConfiguration();
  const connectionType = useGetConnectionType();

  if (isLoading) {
    return <CustomLoader />;
  }
  if (error || !data) {
    if (error instanceof AxiosError && error.status === 503) {
      return <MaintenancePage />;
    }
    return <ErrorPage heading="問題が発生しました。" text="しばらくしてからもう一度お試しください。" />;
  }

  return (
    <BrowserRouter>
      <Auth0ProviderWithRedirectCallback
        clientId={data.clientId}
        domain={data.domain}
        authorizationParams={{
          // eslint-disable-next-line camelcase
          redirect_uri: window.location.origin,
          audience: data.audience,
          ...(connectionType === AUTH_TYPE.Internal && { connection: data.oneAccountConnection }),
        }}
      >
        <UserProvider>
          <QualityCheckCacheProvider>
            <AuthProviderWrapper>
              <AppRoutes />
            </AuthProviderWrapper>
          </QualityCheckCacheProvider>
        </UserProvider>

        <ReactQueryDevtools initialIsOpen={false} />
      </Auth0ProviderWithRedirectCallback>
    </BrowserRouter>
  );
}

export default App;
